/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest =
  {
    ledgerCanisterId: string;
    id: string;
  };

/** @internal */
export const GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$inboundSchema:
  z.ZodType<
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$Outbound =
  {
    ledger_canister_id: string;
    id: string;
  };

/** @internal */
export const GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$outboundSchema:
  z.ZodType<
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$Outbound,
    z.ZodTypeDef,
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$ {
  /** @deprecated use `GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$inboundSchema;
  /** @deprecated use `GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$outboundSchema;
  /** @deprecated use `GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$Outbound` instead. */
  export type Outbound =
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$Outbound;
}

export function getSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequestToJSON(
  getSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest:
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest,
): string {
  return JSON.stringify(
    GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$outboundSchema
      .parse(
        getSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest,
      ),
  );
}

export function getSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetSnsAccountImageApiV1ImagesLedgersLedgerCanisterIdAccountsIdPngGetRequest' from JSON`,
  );
}
